/* eslint-disable react-hooks/exhaustive-deps */
export default function NotFoundComponent() {
  return (
    <div className="container text-center font-weight-bold d-flex justify-content-center mt-5">
      <h1>404 Not Found</h1>
    </div>
  );
}
